import * as productService from 'services/productService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { Paginator } from 'services/dtoModels/paginator';
import type { GetProductsRequest } from 'services/dtoModels/product/getProductsRequest';
import type { SWRResponse } from 'swr';

type SWRProductsData = Awaited<ReturnType<typeof productService.getProductsAsync>>;

const useProducts = (
  params: GetProductsRequest & Paginator
): SWRResponse<SWRProductsData, AxiosError> =>
  useSWR(
    [SWR_PRODUCTS_ENDPOINT, params],
    async ([_, params]) => await productService.getProductsAsync(params)
  );

export const SWR_PRODUCTS_ENDPOINT = 'products';
export default useProducts;
